import Loadable from 'react-loadable';
import LoadingComponent from '../../common/loader/index';

export default [
    {
        path: '/holiday',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../../pages/HolidayContainer'),
            loading: LoadingComponent
        })
    },
    {
        path: '/holiday/add',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../../pages/HolidayDetailContainer'),
            loading: LoadingComponent
        })
    },
    {
        path: '/holiday/:id',
        exact: true,
        auth: true,
        component: Loadable({
            loader: () => import('../../pages/HolidayDetailContainer'),
            loading: LoadingComponent
        })
    }
];
